export const SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION';
export const HIDE_SUCCESS_NOTIFICATION = 'HIDE_SUCCESS_NOTIFICATION';
export const SHOW_FAILURE_NOTIFICATION = 'SHOW_FAILURE_NOTIFICATION';

// CSAT Survey
export const IS_GET_QUESTIONS_INPROGRESS = 'IS_GET_QUESTIONS_INPROGRESS';
export const IS_SUBMIT_INPROGRESS = 'IS_SUBMIT_INPROGRESS';
export const IS_SURVEY_SUBMITTED = 'IS_SUBMIT_SUBMITTED';
export const IS_SURVEY_ENABLED = 'IS_SURVEY_ENABLED';
